import { OrderItemDto } from './OrderItemDto';
import { PurchaseOrderItemDto } from './PurchaseOrderItemDto';

export class OrderDto {

    public readonly orderId: string;
    public readonly orderNumber: string;
    public readonly createdDateTime: string;
    public readonly processStartDateTime: string;
    public readonly deliverToName: string | null;
    public readonly deliverToAddress1: string | null;
    public readonly deliverToAddress2: string | null;
    public readonly deliverToCity: string | null;
    public readonly deliverToStateProv: string | null;
    public readonly deliverToZipPC: string | null;
    public readonly deliverToCountry: string | null;
    public readonly orderNotes : string | null;

    public readonly orderItems: OrderItemDto[] = [];
    public readonly purchaseOrderItems: PurchaseOrderItemDto[] = [];

    constructor(orderId: string, orderNumber: string, createdDateTime: string, processStartDateTime: string,
                deliverToName: string | null, deliverToAddress1: string | null, deliverToAddress2: string | null,
                deliverToCity: string | null, deliverToStateProv: string | null, deliverToZipPC: string | null,
                deliverToCountry: string | null, orderNotes: string | null) {
        this.orderId = orderId;
        this.orderNumber = orderNumber;
        this.createdDateTime = createdDateTime;
        this.processStartDateTime = processStartDateTime;
        this.deliverToName = deliverToName;
        this.deliverToAddress1 = deliverToAddress1;
        this.deliverToAddress2 = deliverToAddress2;
        this.deliverToCity = deliverToCity;
        this.deliverToStateProv = deliverToStateProv;
        this.deliverToZipPC = deliverToZipPC;
        this.deliverToCountry = deliverToCountry;
        this.orderNotes = orderNotes;
    }
}
